import { articleTimestampFormat } from "@util/constant";
import { getFormattedTime } from "@util/helpers";
import dayjs from "dayjs";

export type ArticleTimeStampProps = {
  /** The time when the article was last updated/publish. */
  updatedTime: string;
  /** The time when the article was edited. */
  editedTime: string;
  /** Whether the updated time should be displayed. */
  hasUpdatedTimeDisplayed?: boolean;
};

/**
 * Displays the article's published and updated timestamps.
 * If the updated time is before the edited time, it indicates that the article was edited before it was published.
 */
const ArticleTimeStamp = ({
  updatedTime,
  editedTime,
  hasUpdatedTimeDisplayed = false,
}: ArticleTimeStampProps): React.ReactElement => {
  const isEditedBeforePublished = dayjs(updatedTime) > dayjs(editedTime);

  return (
    <div className="typo-timestamp text-xs text-gray-550">
      <span data-testid="article-published-time">
        Published {getFormattedTime(updatedTime, articleTimestampFormat)}
      </span>

      {hasUpdatedTimeDisplayed && !isEditedBeforePublished ? (
        <span data-testid="article-updated-time">
          {` — Updated ${getFormattedTime(editedTime, articleTimestampFormat)}`}
        </span>
      ) : null}
    </div>
  );
};

export default ArticleTimeStamp;
